import React, { useState, useEffect, useRef } from "react";
import { Card, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "../../../layouts/Navbar";
import { reset } from 'redux-form';
import Sidebar from "../../../layouts/Sidebar";
import { connect, useDispatch } from "react-redux";
import Filter from "../../../assets/images/filter.svg";
import Edit from "../../../assets/images/ui.svg";
import Delete from "../../../assets/images/ux.svg";
import Deliver from "../../../assets/images/deliver.svg";
import Clone from "../../../assets/images/clonee.svg";
import download from "../../../assets/images/download1.svg";
import mail from "../../../assets/images/mail.svg";
import Arrow from "../../../assets/images/pl.svg";
import Search from "../../../assets/images/search.svg";
import Boq from "../../../assets/images/boq-one.png";
import { toast } from "react-toastify";
import BillFilter from "./BillFilter";
import ConvertBoq from "./ConvertBoq";
import {
  getPoUnconvertedList,
  getConfirmQuotDropdown,
  changeDateFormat,
  clearBoq,
  clearConfirmDropdownList,
  clearBoqPreview,
  getExecutiveUrl,
  changePoClassName,
  previewBoq,
  generateBoq,
  sendBoq,
  cloneBoq,
  deleteBoq,
  reviseBoq,
  getProjectOutwardList,
  getInternalTransferProductList,
  clearBoqProjectData,
  cancelBoq,
  setTitle,
  shortStr,
  sendBoqMail,
  getBoqMailDetails,
  getProjectOutwardV2Action
} from "../../../actions";
import Spinner from "../../../Components/loader";
import BOQView from "./BOQView";
import Pagination from "../../../Components/Pagination";
import CloneStatus from "../../../Components/cloningStatus";
import ClonePopup from "../../../Components/clonePopup";
import DeletePopUp from "../vendorpo/deletePopup";
import Projects from "./Projects";
import Outward from "./Outward";
import EmailPopup from "../../../Components/emailPopup";
import BoqMailPopup from "../../../Components/BoqMailPopup";
import Art from "../../../assets/images/art.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import UnConvertBoq from "./UnconvertedBoq";

const role = localStorage.getItem('userRole');

const PoUnconverted = (props) => {
  const dispatch = useDispatch();
  const myRef = useRef();
  
  // State hooks
  const [show, setShow] = useState(false);
  const [boq_list, setBoq_list] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [sortField, setSortField] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = useState("");
  const [sortType, setSortType] = useState("desc");
  const [editShow, setEditShow] = useState(false);
  const [status, setStatus] = useState("DRAFT");
  const [boqData, setBoqData] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [customPopup, setCustomPopup] = useState(false);
  const [id, setId] = useState("");
  const [projectPopup, setProjectPopup] = useState(false);
  const [outwardPopup, setOutwardPopup] = useState(false);
  const [data, setData] = useState([]);
  const [itStr, setItStr] = useState("");
  const [cloned, setCloned] = useState(false);
  const [clonePopup, setClonePopup] = useState(false);
  const [cloneStr, setCloneStr] = useState("");
  const [cloneShow, setCloneShow] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false);
  const [cc, setCc] = useState([]);
  const [unconvertBoqShow, setUnconvertBoqShow] = useState(false);
  const [selectedBoq, setSelectedBoq] = useState(null);

  // Methods converted to functions
  const cancelBoqHandler = async () => {
    var footerData = await cancelBoq(boqData.billOfQuantityId);
    if (footerData?.data?.status === 200) {
      toast(footerData?.data?.data);
      setStatus("CANCELLED");
      listAllData();
    } else {
      toast(footerData?.data?.data);
    }
  };

  const clickPage = () => {
    dispatch(clearBoq());
    dispatch(clearBoqProjectData());
    setTitle("Create BOQ");
    localStorage.setItem("title", "Create BOQ");
    window.location.hash = "/" + role + "/bill_of_quantity/customer_details/add";
  };

  const handleShow = () => {
    dispatch(clearConfirmDropdownList());
    dispatch(getConfirmQuotDropdown());
    setShow(true);
  };

  const handleClose = () => {
    dispatch(clearConfirmDropdownList());
    setShow(false);
  };

  const editVendorShow = (item, str) => {
    if (str === "edit") {
      setTitle("Edit BOQ");
      localStorage.setItem("title", "Edit BOQ");
      window.location.hash = `/${role}/bill_of_quantity/product_details/${item.billOfQuantityId}`;
    } else if (str === "del") {
      setBoqData(item);
      deleteItem(item);
    } else if (str === "clone") {
      setCloned(true);
      setClonePopup(true);
      setCloneStr("Cloning BOQ...Please wait...");
      dispatch(cloneBoq(item.billOfQuantityId));
    } else if (str === "mail") {
      setBoqData(item);
      dispatch(sendBoq(item.billOfQuantityId));
    } else if (str === "deliver") {
      setBoqData(item);
      dispatch(getProjectOutwardV2Action(item.billOfQuantityId));
      projectOpenHandler();
    } else {
      dispatch(clearBoqPreview());
      dispatch(clearBoqProjectData());
      dispatch(previewBoq(item.billOfQuantityId));
      setEditShow(true);
      setStatus(item.status);
      setBoqData(item);
    }
  };

  const editVendorClose = () => {
    dispatch(clearBoqPreview());
    setEditShow(false);
  };

  const goToPoPage = () => {
    const { history } = props;
    dispatch(clearBoq());
    if (status === "DRAFT") {
      setTitle("Edit BOQ");
      history.push(`/${role}/bill_of_quantity/product_details/${boqData.billOfQuantityId}`);
    } else {
      revisePoHandler();
    }
  };

  const projectOpenHandler = () => {
    setProjectPopup(true);
    setEditShow(false);
    setItStr("project");
  };

  const projectCloseHandler = () => {
    setProjectPopup(false);
    setItStr("");
  };

  const outwardOpenHandler = (item) => {
    dispatch(getInternalTransferProductList(boqData.billOfQuantityId));
    let dataValues = {
      billOfQuantityId: item.billOfQuantityId,
      billOfQuantityNumber: item.billOfQuantityNumber,
      customerName: item.customerName,
      outwardProductList: item?.outwardProductList,
      projectId: item.projectId,
      projectName: item.projectName,
      purchaseOrderId: item.purchaseOrderId,
      status: item.status
    };
    setOutwardPopup(true);
    setProjectPopup(false);
    setEditShow(false);
    setItStr(itStr === "project" ? "project" : "IT");
    setData(dataValues);
  };

  const outwardCloseHandler = () => {
    setOutwardPopup(false);
    setItStr("");
  };

  const generatePoHandler = () => {
    if (boqData.projectName === null) {
      toast("Please edit project to generate BOQ");
    } else {
      dispatch(generateBoq(boqData.billOfQuantityId));
    }
  };

  const sendPohandler = () => {
    dispatch(sendBoq(boqData.billOfQuantityId));
  };

  const sendMailOpen = () => {
    if (boqData.length !== 0) {
      dispatch(getBoqMailDetails(boqData.billOfQuantityId));
    }
    setEmailPopup(true);
    setEditShow(false);
  };

  const sendMailClose = () => {
    setEmailPopup(false);
  };

  const sendPoMailSubmit = (values, dispatch) => {
    const newItems = cc.map((item) => item.value);
    let data = {
      "from": values.from,
      "to": values.to,
      "cc": newItems,
      "id": boqData.billOfQuantityId,
      "subject": values.subject
    };
    dispatch(sendBoqMail(data));
    dispatch(reset("SecondaryEmailForm"));
  };

  const getCCs = (val) => {
    setCc(val);
  };

  const clonePoHandler = () => {
    setCloned(true);
    setClonePopup(true);
    setCloneStr("Cloning BOQ...Please wait...");
    dispatch(cloneBoq(boqData.billOfQuantityId));
  };

  const revisePoHandler = () => {
    setCloned(true);
    setClonePopup(true);
    setCloneStr("Revising BOQ...Please wait...");
    dispatch(reviseBoq(boqData.billOfQuantityId));
  };

  const deleteItem = (item) => {
    setDeletePopup(true);
  };

  const deleteItemClose = () => {
    setDeletePopup(false);
  };

  const deletePoHandler = () => {
    dispatch(deleteBoq(boqData.billOfQuantityId));
  };

  const onChange = (pageNo) => {
    setPageNo(pageNo);
    const url = getExecutiveUrl(pageNo, searchKey, filterData, sortField, sortType);
    dispatch(getPoUnconvertedList(url));
  };

  const searchHandler = (e) => {
    setSearchKey(e.target.value);
  };

  const sortHandler = (sortField) => {
    setSortField(sortField);
    let type = sortType;
    if (sortType === 'desc') {
      type = 'asc';
      setSortType('asc');
    } else {
      type = 'desc';
      setSortType('desc');
    }
    let url = getExecutiveUrl(pageNo, searchKey, filterData, sortField, type);
    dispatch(getPoUnconvertedList(url));
  };

  const filterSubmit = (filterData) => {
    setFilterData(filterData);
    let url = getExecutiveUrl(pageNo, searchKey, filterData, sortField, sortType);
    dispatch(getPoUnconvertedList(url));
  };

  const resetHandler = () => {
    setFilterData({});
    let url = getExecutiveUrl(pageNo, searchKey, {}, sortField, sortType);
    dispatch(getPoUnconvertedList(url));
  };

  const listAllData = () => {
    let url = getExecutiveUrl(pageNo, searchKey, filterData, sortField, sortType);
    dispatch(getPoUnconvertedList(url));
  };

  const handleUnconvertBoqOpen = (item) => {
    setSelectedBoq(item);
    setUnconvertBoqShow(true);
  };
  const handleUnconvertBoqClose = () => {
    setUnconvertBoqShow(false);
    setSelectedBoq(null);
  };

  // useEffect for componentDidMount
  useEffect(() => {
    dispatch(getPoUnconvertedList('page=0'));
  }, [dispatch]);

  // useEffect for componentDidUpdate - watching props changes
  useEffect(() => {
    if (props.poUnconvertedList !== boq_list) {
      setBoq_list(props.poUnconvertedList);
    }
  }, [props.poUnconvertedList]);

  useEffect(() => {
    if (props.generateData) {
      if (props.generateData.status === 200) {
        setStatus("GENERATED");
        listAllData();
        toast(props.generateData.data);
      } else {
        toast(props.generateData.data);
      }
    }
  }, [props.generateData]);

  useEffect(() => {
    if (props.sendData) {
      if (props.sendData.status === 200) {
        toast(props.sendData.data);
        listAllData();
        setEditShow(false);
      } else {
        toast(props.sendData.data);
      }
    }
  }, [props.sendData]);

  useEffect(() => {
    if (props.cloneData) {
      if (props.cloneData.status === 200) {
        toast(props.cloneData.message);
        listAllData();
        setEditShow(false);
        setClonePopup(false);
        setCloneShow(true);
        setCloneStr("BOQ Cloned Successfully");
        setTimeout(() => {
          setCloneShow(false);
          setCloneStr("");
          setCloned(null);
        }, 1200);
      } else {
        setClonePopup(false);
        toast(props.cloneData.data);
      }
    }
  }, [props.cloneData]);

  useEffect(() => {
    if (props.reviseData) {
      if (props.reviseData.status === 200) {
        toast(props.reviseData.message);
        listAllData();
        setEditShow(false);
        setClonePopup(false);
        setCloneShow(true);
        setCloneStr("Boq Revised Successfully");
        setTimeout(() => {
          setCloneShow(false);
          setCloneStr("");
          setCloned(null);
        }, 1200);
      } else {
        setClonePopup(false);
        toast(props.reviseData.data);
      }
    }
  }, [props.reviseData]);

  useEffect(() => {
    if (props.deleteBoq) {
      if (props.deleteBoq.status === 200) {
        toast(props.deleteBoq.data);
        listAllData();
        setDeletePopup(false);
        setEditShow(false);
      } else {
        toast(props.deleteBoq.data);
      }
    }
  }, [props.deleteBoq]);

  useEffect(() => {
    if (props.boqMailSuccess) {
      if (props.boqMailSuccess.status === 200) {
        toast(props.boqMailSuccess.data);
        listAllData();
        setEmailPopup(false);
      } else {
        toast(props.boqMailSuccess.data);
      }
    }
  }, [props.boqMailSuccess]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchKey(searchKey);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [searchKey]);

  useEffect(() => {
    const url = getExecutiveUrl(pageNo, debouncedSearchKey, filterData, sortField, sortType);
    dispatch(getPoUnconvertedList(url));
  }, [debouncedSearchKey]);

  let dataForPagination = {
    totalElements: boq_list.totalElements,
    totalPages: boq_list.totalPages,
    offset: boq_list?.pageable?.offset,
    numberOfElements: boq_list.numberOfElements,
    num: (boq_list?.number) + 1
  };

  return (
    <div>
      <Navbar />
      <div className="dashboard-page">
        <div className="dashboard-sidebar">
          <Sidebar />
        </div>
        <div className="dashboard-main">
          <Card className="staff-page">
            <div className="page-head-split">
              <div className="head-colums" style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="head-part-tab" >
                  <img src={Boq} alt="..." className="head-imgs" />
                  <h5>Unconverted PO’s</h5>
                </div>
                <div className="tab-linkk">
                  <Link to={"/" + role + "/bill_of_quantity"}>Bill Of Quantity</Link>
                  <Link to={"/" + role + "/bill_of_quantity/unconverted-po"} className="active"> Unconverted PO’s</Link>
                </div>
                <div className="customer-search">
                  <span><img src={Search} alt=".." className="search-img" /></span>
                  <Form.Control type="search" placeholder="Search" onChange={searchHandler} className="main-search" />
                </div>
              </div>
            </div>
            <div className="table-class">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    {/* <th scope="col">
                      ID <img src={Filter} alt="..." onClick={(e) => sortHandler("boq.bill_of_quantity_id")} />
                    </th> */}
                    <th scope="col">BOQ Number <img src={Filter} alt="..." onClick={(e) => sortHandler("boq.bill_of_quantity_number")} /></th>
                    <th scope="col">
                      Customer Name <img src={Filter} alt="..." onClick={(e) => sortHandler("c.customer_first_name")} />
                    </th>
                    <th scope="col">
                      Project Name <img src={Filter} alt="..." onClick={(e) => sortHandler("bqp.project_name")} />
                    </th>
                    <th scope="col">
                      Generated By <img src={Filter} alt="..." onClick={(e) => sortHandler("staffName")} />
                    </th>
                    <th scope="col" >
                      Created At <img src={Filter} alt="..." onClick={(e) => sortHandler("boq.created_at")} />
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                      Status <img src={Filter} alt="..." onClick={(e) => sortHandler("boq.status")} />
                    </th>
                    {/* <th scope="col" style={{ textAlign: "center" }}>Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {boq_list && boq_list?.length > 0 ? (
                    boq_list?.map((item, i) => {
                      return <tr key={i} style={{ cursor: "pointer" }}>
                        {/* <td onClick={() => editVendorShow(item, "")}>{item.billOfQuantityId}</td> */}
                        <td>{item.billOfQuantityNumber ?? "-"}</td>
                        <td className="customer_name_size">{item.customerName}</td>
                        <td className="customer_name_size">
                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {item.projectName || "-"}</Tooltip>}>
                            <span className="d-inline-block">
                              {item.projectName || "-"}
                            </span>
                          </OverlayTrigger>
                        </td>
                        <td>{item?.generatedBy}</td>
                        <td>{changeDateFormat(item.createdAt)}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            style={{ width: "145px" }}
                            className={changePoClassName(item.boqStatus)}
                            onClick={() => handleUnconvertBoqOpen(item)}
                          >
                            {item.boqStatus}
                          </button>
                        </td>
                        {/* <td style={{ textAlign: "center" }}>
                          {
                            (() => {
                              if (item.boqStatus === "DRAFT") {
                                return (
                                  <>
                                    <img src={Edit} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "edit")} />
                                    <img src={Delete} alt="" className="delete-staff" onClick={() => editVendorShow(item, "del")} />
                                  </>
                                )
                              } else if (item.boqStatus === "GENERATED") {
                                return (
                                  <>
                                    <img src={download} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "")} />
                                    <img src={mail} alt="" className="delete-staff" onClick={() => editVendorShow(item, "mail")} />
                                  </>
                                )
                              } else if (item.boqStatus === "SENT") {
                                return (
                                  <>
                                    <img src={Clone} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "clone")} />
                                    <img src={download} alt="" className="delete-staff" onClick={() => editVendorShow(item, "")} />
                                  </>
                                )
                              } else if (item.boqStatus === "CONVERTED") {
                                return (
                                  <>
                                    <img src={download} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "")} />
                                    <img src={Clone} alt="" className="delete-staff" onClick={() => editVendorShow(item, "clone")} />
                                  </>
                                )
                              } else if (item.boqStatus === "REVISED") {
                                return (
                                  <>
                                    <img src={Clone} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "clone")} />
                                    <img src={download} alt="" className="delete-staff" onClick={() => editVendorShow(item, "")} />
                                  </>
                                )
                              } else if (item.boqStatus === "CANCELLED") {
                                return (
                                  <>
                                    <img src={Clone} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "clone")} />
                                    <img src={download} alt="" className="delete-staff" onClick={() => editVendorShow(item, "")} />
                                  </>
                                )
                              } else if (item.boqStatus === "PARTIALLY_RECEIVED") {
                                return (
                                  <>
                                    <img src={download} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "")} />
                                    <img src={Deliver} alt="" className="delete-staff" onClick={() => editVendorShow(item, "deliver")} />
                                  </>
                                )
                              } else if (item.boqStatus === "PARTIALLY_DELIVERED") {
                                return (
                                  <>
                                    <img src={download} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "")} />
                                    <img src={Deliver} alt="" className="delete-staff" onClick={() => editVendorShow(item, "deliver")} />
                                  </>
                                )
                              } else if(item.boqStatus === "RECEIVED") {
                                return (
                                  <>
                                    <img src={download} alt="" className="delete-staff" onClick={() => editVendorShow(item, "")} />
                                    <img src={Deliver} alt="" className="delete-staff" onClick={() => editVendorShow(item, "deliver")} />
                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    <img src={Clone} alt="" className="Edit-staffs" onClick={() => editVendorShow(item, "clone")} />
                                    <img src={download} alt="" className="delete-staff" onClick={() => editVendorShow(item, "")} />
                                  </>
                                )
                              }
                            })()
                          }
                        </td> */}
                      </tr>
                    })) : !props.loading ?
                    <h1 className="empty-data">No Records Found</h1> :
                    <Spinner />
                  }
                </tbody>
              </table>
            </div>
          </Card>
          <BOQView
            show={editShow}
            data={status}
            onHide={editVendorClose}
            goTo={goToPoPage}
            generate={generatePoHandler}
            send={sendPohandler}
            sendMail={sendMailOpen}
            item={boqData}
            clone={clonePoHandler}
            delete={deleteItem}
            revise={revisePoHandler}
            deliver={projectOpenHandler}
            internal={outwardOpenHandler}
            cancel={cancelBoqHandler}
          />
          <DeletePopUp
            show={deletePopup}
            onHide={deleteItemClose}
            deleteItem={deletePoHandler}
          />
          <Projects
            show={projectPopup}
            boqId={boqData.billOfQuantityId}
            onHide={projectCloseHandler}
            handleShow={outwardOpenHandler}
          />
          <Outward
            show={outwardPopup}
            id={boqData?.billOfQuantityId}
            onHide={outwardCloseHandler}
            data={data}
            str={itStr}
          />
          <CloneStatus
            show={clonePopup}
            str={cloneStr}
            onHide={false}
          />
          <ClonePopup
            show={cloneShow}
            str={cloneStr}
            onHide={false}
            cloned={cloned}
          />
          <BoqMailPopup
            show={emailPopup}
            onHide={sendMailClose}
            onSubmit={sendPoMailSubmit}
            getCC={getCCs}
          />
          <UnConvertBoq
            show={unconvertBoqShow}
            onHide={handleUnconvertBoqClose}
            quotData={selectedBoq}
            allData={listAllData}
          />
          {/* <Pagination data={dataForPagination} onChange={onChange} /> */}
        </div>
      </div >
      <div className="template-two-design" style={{ display: "none" }} ref={myRef} dangerouslySetInnerHTML={{ __html: `${props.previewBoqText}` }} />
    </div >
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.boq.loading,
    boqList: state.boq.boqList,
    convertBoqList: state.boq.convertBoqList,
    previewBoqText: state.boq.previewBoqText,
    generateData: state.boq.generateData,
    sendData: state.boq.sendData,
    cloneData: state.boq.cloneData,
    reviseData: state.boq.reviseData,
    deleteBoq: state.boq.deleteBoq,
    boqMailSuccess: state.boq.boqMailSuccess,
    poUnconvertedList: state.boq.poUnconvertedList,
  };
};

export default connect(mapStateToProps)(PoUnconverted);

